var transportationHubOptions = {
    isSelectedTransportationHub: false
}
var hubsDeliveryMethod;

var CheckoutHubJs = (function ($) {
    var $radioButtons;
    var $clickElem;

    var hasContent = function (sel) {
        return true && $(sel).html().trim();
    };

    var initView = function (radioButtonsSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'));
        $(radioBSel).on("click", function () {
            showHideDeliveryAddress($(this));
        });
    };
    var showHideDeliveryAddress = function (target) {
        if (target.attr("value") === hubsDeliveryMethod) {
            if (hasContent('.j-trHub-delivery-details .j-hub-code')) {
                $(".j-trHub-delivery-details").show();
            } else {
                target.prop("checked", false);
            }
        } else {
            $(".j-trHub-delivery-details").hide();
        }
    };
    var addChangeCityHandler = function (countySel) {
        $(countySel).on('change', function () {
            hideHubsAddressInfo(true);
            clearHubsFields();
        });
    }
    var clearHubsFields = function () {
        $(".j-trHub-delivery-details").hide();
        $(".j-hub-code").html("");
        $(".j-hub-phone").html("");
        $(".j-hub-zip").html("");
        $(".j-hub-street").html("");
        transportationHubOptions.isSelectedTransportationHub = false;
        transportationHubOptions.street = "";
        transportationHubOptions.city = "";
        transportationHubOptions.zip = "";
        transportationHubOptions.phone = "";
        transportationHubOptions.code = "";
    }
    var addHubsRadioButtonHandler = function (radioButtonSel, searchFormSel, citySel) {
        $radioButtons = $(radioButtonSel);
        $radioButtons.filter("[value='" + hubsDeliveryMethod + "']").on("click", function () {
            $clickElem = $(this);
            if (!hasContent('.j-hub-code')) {
                var form = $(searchFormSel);
                openTransportationHubsDialog(citySel, form);
            } else {
                window.THEME.$document.trigger("deliveryChange", [$(this)]);
            }
        });
    };

    function openWindow(form, citySel) {
        if ($(citySel).val()) {
            setCityOnTransportationHubsSearchForm(form, citySel);
            loadTransportationHubsPopupAjax(form, form.data("action"), onCloseHubsFunction);
        } else {
            openHubsNoCityAlert();
        }
    }

    var onCloseHubsFunction = function () {
        if (transportationHubOptions.isSelectedTransportationHub === true) {
            $clickElem.data("selected", true);
            $clickElem.prop("checked", true);
            window.THEME.$document.trigger("deliveryChange", [$(this)]);
            fillHubsAddressInfo();
        } else {
            hideHubsAddressInfo();
        }
    };
    var hideHubsAddressInfo = function (forceHide) {
        if (!hasContent('.j-trHub-delivery-details .j-hub-code') || forceHide) {
            $('.j-trHub-delivery-details').hide();
            $radioButtons.filter("[value='" + hubsDeliveryMethod + "']").first().prop("checked", false);
            var defaultDeliveryMethodElement = $("#defaultDeliveryMethod");
            if (defaultDeliveryMethodElement && defaultDeliveryMethodElement.val()) {
                $(".j-delivery-method-radio-buttons input[type='radio']")
                    .filter("[value='" + defaultDeliveryMethodElement.val() + "']")
                    .first()
                    .prop("checked", true).trigger("change");
            }
        }
    };
    var fillHubsAddressInfo = function () {
        $(".j-hub-code").html(transportationHubOptions.code);
        $(".j-hub-phone").html(transportationHubOptions.phone);
        $(".j-hub-zip").html(transportationHubOptions.zip + " , " + transportationHubOptions.city);
        $(".j-hub-street").html(transportationHubOptions.street);
        $(".j-trHub-delivery-details").show();
    }
    var openTransportationHubsDialog = function (citySel, form) {
        openWindow(form, citySel)
    };
    var openHubsNoCityAlert = function () {
        $('.j-alert-ok-button').on('click', function () {
            jQuery.fancybox.close();
        });
        jQuery.fancybox({
            'content': $('#j-no-city-entered-alert-hubs'),
            beforeClose: function () {
                $('.j-checkout-invoice-details-city').trigger("focus");
            }, afterClose: function () {
                if (hasContent('.j-trHub-delivery-details .j-hub-code')) {
                    $('.j-delivery-method-radio-buttons input[type=radio]:checked').prop('checked', true);
                    fillHubsAddressInfo();
                } else {
                    $('.j-delivery-method-radio-buttons input[type=radio]:checked').prop('checked', false);
                    hideHubsAddressInfo();
                }
            },
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    };
    var setCityOnTransportationHubsSearchForm = function (form, citySel) {
        var cityName = $(citySel).first().val();
        if (cityName == '') {
            cityName = $(citySel)[0].textContent;
        }
        form.find("input[name='city']").first().val(cityName);
    };
    var addHubsChangeButtonHandler = function (editButton, searchFormSel, citySel, radioButtonsSel) {
        $(editButton).on("click", function (event) {
            event.preventDefault();
            var form = $(searchFormSel);
            $clickElem = $(radioButtonsSel).filter("[value='" + hubsDeliveryMethod + "']");
            openTransportationHubsDialog(citySel, form);
        });
    };
    var addClickHandlerHubsEditButton = function (editButton, searchFormSel) {
        $(editButton).on("click", function (event) {
            if ($(this).data("delivery-method") === hubsDeliveryMethod) {
                event.preventDefault();
                var form = $(searchFormSel);
                loadTransportationHubsPopupAjax(form, form.data("action"), onCloseHubsStep3Function);
            }
        });
    };
    var onCloseHubsStep3Function = function () {
        if (transportationHubOptions.isSelectedTransportationHub === true) {
            $('.j-hubs-delivery-code').html(transportationHubOptions.code);
            $('.j-hubs-delivery-address-street').html(transportationHubOptions.street);
            $('.j-hubs-delivery-city').html(transportationHubOptions.zip + ", " + transportationHubOptions.city);
            $('.j-hubs-delivery-address-phone').html(transportationHubOptions.phone);
        }
    };

    return {
        initView: initView,
        showHideDeliveryAddress: showHideDeliveryAddress,
        addHubsRadioButtonHandler: addHubsRadioButtonHandler,
        addHubsChangeButtonHandler: addHubsChangeButtonHandler,
        addClickHandlerHubsEditButton: addClickHandlerHubsEditButton,
        addChangeCityHandler: addChangeCityHandler,
    }
})(jQuery);

$(document).ready(function () {
    if (typeof $("#hubsRadioButton") !== 'undefined' && typeof $("#hubsRadioButton").val() !== 'undefined') {
        hubsDeliveryMethod = $("#hubsRadioButton").val();
        CheckoutHubJs.initView(".j-delivery-method-radio-buttons");
        var radioButtonsSel = ".j-delivery-method-radio-buttons input[type='radio']";
        var searchFormSel = "#j-search-transportation-hubs-form";
        var citySel = ".j-checkout-invoice-details-city";
        CheckoutHubJs.addHubsRadioButtonHandler(radioButtonsSel, searchFormSel, citySel);
        var changeButton = ".j-hubs-change";
        CheckoutHubJs.addHubsChangeButtonHandler(changeButton, searchFormSel, citySel, changeButton);
        CheckoutHubJs.addChangeCityHandler(".invoice-town-select");
    }
    if (typeof hubsDeliveryMethod !== 'undefined') {
        var editButton = "#j_checkout_delivery_edit";
        var searchFormSel = "#j-search-transportation-hubs-form";
        CheckoutHubJs.addClickHandlerHubsEditButton(editButton, searchFormSel);
    }
});
